"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingDefaultsByPropertyIdReducer = void 0;
exports.pricingDefaultsByPropertyIdReducer = (state = {}, action = {}) => {
    switch (action.type) {
        case 'PRICING_DEFAULTS_GET_BY_PROPERTY_ID_RECEIVE':
        case 'PRICING_DEFAULTS_UPSERT_BY_PROPERTY_ID_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: action.payload.pricingDefaults });
        case 'PRICING_DEFAULTS_DELETE_BY_PROPERTY_ID_RECEIVE':
            const _a = state, _b = action.payload.propertyId, defaults = _a[_b], updatedState = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return updatedState;
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map